import React, { useCallback } from 'react';
import { windowIsDefined } from 'app/helpers/windowIsDefined';
import { desktopContentWidth } from 'app/styles/media';
import PlayerStatsGrid from 'app/components/team/playerstats/PlayerStatsGrid';
const MOBILE_OFFSET = 254;
export default function PlayerStatsSeasonGrid(_ref) {
  let {
    players,
    isLoading,
    error
  } = _ref;
  const calcMaxHeight = useCallback(() => {
    if (windowIsDefined && window.innerWidth < desktopContentWidth) {
      return window.innerHeight - MOBILE_OFFSET;
    }
    if (isLoading || !players.length || error) {
      return 350;
    }
    return '100%';
  }, [isLoading, players, error]);
  return /*#__PURE__*/React.createElement(PlayerStatsGrid, {
    type: "season",
    players: players,
    isLoading: isLoading,
    error: error,
    calcMaxHeight: calcMaxHeight,
    withTopEleven: true,
    hideFooter: true,
    getRowHeight: () => 'auto',
    "data-sentry-element": "PlayerStatsGrid",
    "data-sentry-component": "PlayerStatsSeasonGrid",
    "data-sentry-source-file": "PlayerStatsSeasonGrid.tsx"
  });
}